import React, {useState} from 'react'
import {KTSVG} from 'helpers'
import {useAuth} from 'context/AuthProvider'
import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router-dom'

const HeaderDropdown = () => {
 const {t} = useTranslation()
 const navigate = useNavigate()
 const [dropdownPopoverShow, setDropdownPopoverShow] =
  useState('hidden')
 const {userData, logout} = useAuth()

 const dropdownShow = () => {
  if (dropdownPopoverShow === 'block') {
   setDropdownPopoverShow('hidden')
  } else {
   setDropdownPopoverShow('block')
  }
 }

 const handleMyAccountClick = () => {
  dropdownShow()
  navigate('/my-account')
 }

 const logoutUser = () => {
  dropdownShow()
  logout()
 }

 return (
  <>
   <div className='relative flex'>
    <div className='mr-2 text-center'>
     <div className='text-[#33393D] font-semibold text-sm'>
      {userData?.name}
     </div>
     <div className='text-[#5A6066] font-semibold text-[10px]'>
      {userData?.userCategory}
     </div>
    </div>
    <div className='relative inline-block '>
     <button
      className='relative z-10 block'
      onClick={dropdownShow}
     >
      <div className='relative items-center justify-center flex rounded-lg border-[#CED8E0] bg-[#F5F8FA] w-9 h-9 '>
       <KTSVG
        path={`/media/icons/user.svg`}
        svgClassName={`w-[18px] h-[18px] text-white`}
       />
       <KTSVG
        path={`/media/icons/userMenu.svg`}
        svgClassName={`absolute right-[-12px] bottom-[-12px]`}
       />
      </div>
     </button>

     <div
      className={` ${dropdownPopoverShow} absolute right-2 z-20 w-48 py-2 mt-2 bg-white rounded-md shadow-xl `}
     >
      <div className='flex items-center text-sm text-gray-600 capitalize transition-colors duration-200 transform  '>
       <ul className='w-full'>
        <li
         className='mx-1 flex hover:bg-gray-100 p-1 cursor-pointer'
         onClick={handleMyAccountClick}
        >
         <svg
          xmlns='http://www.w3.org/2000/svg'
          className='h-5 w-5 mr-2'
          fill='none'
          viewBox='0 0 24 24'
          stroke='currentColor'
          strokeWidth='2'
         >
          <path
           strokeLinecap='round'
           strokeLinejoin='round'
           d='M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z'
          />
         </svg>
         {t('common.myAccount')}
        </li>
       </ul>
      </div>
      <button
       onClick={logoutUser}
       className='flex items-center p-1 text-sm text-gray-600 capitalize transition-colors duration-200 transform  hover:bg-gray-100'
      >
       <svg
        className='w-5 h-5 mx-1'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
       >
        <path
         d='M19 21H10C8.89543 21 8 20.1046 8 19V15H10V19H19V5H10V9H8V5C8 3.89543 8.89543 3 10 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21ZM12 16V13H3V11H12V8L17 12L12 16Z'
         fill='currentColor'
        ></path>
       </svg>
       <span className='mx-1'>{t('common.logout')}</span>
      </button>
     </div>
    </div>
   </div>
  </>
 )
}

export default HeaderDropdown
